<template>
  <div class="d-flex flex-column ga-4">
    <v-alert type="info" density="comfortable">
      {{ $t("ncrm.workflows.nodeSettings.mailjetTelegram.hint") }}
    </v-alert>

    <v-switch
      v-model="form.status"
      :true-value="'active'"
      :false-value="'inactive'"
      color="primary"
      hide-details
      :label="$t('ncrm.workflows.nodeSettings.active')"
    />

    <v-select
      v-model="form.eventTypes"
      :items="eventTypeOptions"
      item-title="label"
      item-value="value"
      multiple
      chips
      :label="$t('ncrm.workflows.nodeSettings.mailjetTelegram.eventTypes')"
      :hint="$t('ncrm.workflows.nodeSettings.mailjetTelegram.eventTypesHint')"
      persistent-hint
      hide-details="auto"
      :menu-props="selectMenuProps"
    />

    <v-divider />

    <NcrmWorkflowTelegramNotify :config="form.telegram" :menu-props="selectMenuProps" />
  </div>
</template>

<script>
import NcrmWorkflowTelegramNotify from "@/components/ncrm/workflows/NcrmWorkflowTelegramNotify.vue";
import { MAILJET_TRIGGER_EVENT_TYPES } from "@/Utile/ncrmMailjetEngagementWorkflow.mjs";

export default {
  name: "NcrmWorkflowMailjetTelegramSettings",
  components: { NcrmWorkflowTelegramNotify },
  props: {
    settings: { type: Object, default: () => ({}) },
    selectMenuProps: { type: Object, default: () => ({ maxHeight: 320, zIndex: 2710 }) },
  },
  emits: ["update:value"],
  data() {
    return { form: this.buildForm(this.settings) };
  },
  computed: {
    eventTypeOptions() {
      return MAILJET_TRIGGER_EVENT_TYPES.map((value) => ({
        value,
        label: this.$t(`ncrm.workflows.nodeSettings.mailjetTrigger.events.${value}`),
      }));
    },
  },
  watch: {
    settings: { deep: true, handler(next) { this.form = this.buildForm(next); this.emitValue(); } },
    form: { deep: true, handler() { this.emitValue(); } },
  },
  mounted() { this.emitValue(); },
  methods: {
    buildForm(settings = {}) {
      const tg = settings.telegram || {};
      const requested = Array.isArray(settings.eventTypes) ? settings.eventTypes : [...MAILJET_TRIGGER_EVENT_TYPES];
      const eventTypes = MAILJET_TRIGGER_EVENT_TYPES.filter((t) => requested.includes(t));
      return {
        status: settings.status === "active" ? "active" : "inactive",
        eventTypes: eventTypes.length ? eventTypes : [...MAILJET_TRIGGER_EVENT_TYPES],
        telegram: {
          enabled: !!tg.enabled,
          recipientUserIds: Array.isArray(tg.recipientUserIds) ? [...tg.recipientUserIds] : [],
        },
      };
    },
    emitValue() {
      this.$emit("update:value", {
        status: this.form.status,
        eventTypes: [...this.form.eventTypes],
        telegram: {
          enabled: !!this.form.telegram.enabled,
          recipientUserIds: Array.isArray(this.form.telegram.recipientUserIds) ? [...this.form.telegram.recipientUserIds] : [],
        },
      });
    },
  },
};
</script>
